import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { EditorData } from '../../state/GlobalFiltersV2/EditorData';

const updateGlobalFiltersV2EditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.GLOBAL_FILTERS_V2_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.GLOBAL_FILTERS_V2_EDITOR_DATA_FETCHED:
      return { ...state, globalFiltersV2EditorData: action.data };
    case ActionType.GLOBAL_FILTERS_V2_EDITOR_DATA_COPIED:
      return { ...state, globalFiltersV2EditorData: { ...action.data } };
    case ActionType.GLOBAL_FILTERS_V2_EDITOR_DATA_UPDATED:
      return { ...state, globalFiltersV2EditorData: { ...state.globalFiltersV2EditorData, ...action.data } };
    case ActionType.GLOBAL_FILTERS_V2_EDITOR_DATA_SAVED:
      return { ...state };
    case ActionType.GLOBAL_FILTERS_V2_EDITOR_DATA_VALIDATED:
      return { ...state, validation: { ...action.data } };
    case ActionType.GLOBAL_FILTERS_V2_EDITOR_SET_BOUND_ITEM:
      return { ...state, globalFiltersV2EditorData: { ...state.globalFiltersV2EditorData, ...action.data } };
    default:
      return state;
  }
};

export default updateGlobalFiltersV2EditorData;
